import { render, staticRenderFns } from "./ImportFlatFileStep.vue?vue&type=template&id=31db00a9&"
import script from "./ImportFlatFileStep.vue?vue&type=script&lang=js&"
export * from "./ImportFlatFileStep.vue?vue&type=script&lang=js&"
import style0 from "./ImportFlatFileStep.vue?vue&type=style&index=0&id=31db00a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports